import { ViewFactory } from 'src/3rds/cube-react'

import { BloqueiosScope } from '../Bloqueios.scopes'
import BloqueiosView from './Bloqueios.view'

export { BloqueiosView } from './Bloqueios.view'

export function registerViews(rv = ViewFactory.register) {
    rv(BloqueiosScope, BloqueiosView)
}
